<div class="popover-wrapper">
  <ng-content></ng-content>

  <div
    class="popover-content"
    *ngIf="show"
    [ngClass]="position"
    [style.width]="width"
    [innerHTML]="content">
  </div>
</div>